export function matchUrlRegex(url: string, regex: RegExp) {
  const match = url.match(regex);
  return match ? match[1] : undefined;
}
